import { render, staticRenderFns } from "./Trends.vue?vue&type=template&id=b9c5ac8e&scoped=true"
import script from "./Trends.vue?vue&type=script&lang=js"
export * from "./Trends.vue?vue&type=script&lang=js"
import style0 from "./Trends.vue?vue&type=style&index=0&id=b9c5ac8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c5ac8e",
  null
  
)

export default component.exports